import Markdown from 'react-markdown';
import type { DecoratedTask } from '@witmetrics/utils';
import { classes } from './utils';

export type TaskNotesProps = {
  task: DecoratedTask;
};

export default function TaskNotes({ task }: TaskNotesProps) {
  return (
    <div className={classes.wrapper}>
      <Markdown>{task.description}</Markdown>
    </div>
  );
}
